import { render } from "./ContactThankYou.vue?vue&type=template&id=1da1ca1a&lang=html"
import script from "./ContactThankYou.vue?vue&type=script&lang=js"
export * from "./ContactThankYou.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__